import AgentFunnel from "@/views/console/AgentFunnel.vue";
import C from "@/utils/constants";

export default [
  {
    path: "agent-funnel",
    component: AgentFunnel,
    meta: {
      roles: [C.ROLE.AGENT],
    },
    children: [
      {
        path: "",
        name: "agent-funnel",
        component: () =>
          import("../components/console/agent-funnel/AgentFunnelList.vue"),
        meta: {
          roles: [C.ROLE.AGENT],
        },
        children: [
          // {
          //   path: "",
          //   redirect: { name: "agent-funnel-buyer" },
          //   meta: {
          //     roles: [C.ROLE.AGENT],
          //   },
          // },
          // {
          //   path: "buyer",
          //   name: "agent-funnel-buyer",
          //   component: () =>
          //     import(
          //       "../components/console/agent-funnel/AgentFunnelListBuyer.vue"
          //     ),
          //   meta: {
          //     roles: [C.ROLE.AGENT],
          //   },
          // },
          // {
          //   path: "seller",
          //   name: "agent-funnel-seller",
          //   component: () =>
          //     import(
          //       "../components/console/agent-funnel/AgentFunnelListSeller.vue"
          //     ),
          //   meta: {
          //     roles: [C.ROLE.AGENT],
          //   },
          // },
          // {
          //   path: "renter",
          //   name: "agent-funnel-renter",
          //   component: () =>
          //     import(
          //       "../components/console/agent-funnel/AgentFunnelListRenter.vue"
          //     ),
          //   meta: {
          //     roles: [C.ROLE.AGENT],
          //   },
          // },
        ],
      },
    ],
  },
];
